// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3AxBl","list":"styles_list__1JI-H"};